import type { PageClientDTO } from "@/dto/page.dto";
import { Loader } from "lucide-react";
import { Badge } from "~/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "~/components/ui/tooltip";

export function PageStatus({ status }: { status: PageClientDTO["status"] }) {
  const getStatusContent = () => {
    switch (status) {
      case "completed":
        return null;
      case "error":
        return (
          <Badge
            variant="outline"
            className="border-rose-300 bg-rose-50 text-rose-500 dark:bg-rose-200 dark:border-rose-400 dark:text-rose-600 mr-1"
          >
            Error
          </Badge>
        );
      default:
        return (
          <Badge variant="outline" className="mr-1">
            <Loader
              size={9}
              className="animate-spin text-muted-foreground !w-3 !h-3"
              style={{
                animationDuration: "2.5s",
              }}
            />
            Processing
          </Badge>
        );
    }
  };

  const getStatusText = () => {
    switch (status) {
      case "pending":
      case "in_progress":
        return "Processing page";
      case "completed":
        return "Page is ready";
      case "error":
        return "Error processing page";
      default:
        return status;
    }
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger
          className="ml-[0.5] flex items-center justify-center"
          asChild
        >
          {getStatusContent()}
        </TooltipTrigger>
        <TooltipContent sideOffset={-3}>
          <p>{getStatusText()}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
